let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("awYAY")).then(() => parcelRequire('9lbX1'));